import { Component, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { Corporation, ForwarderService, PagerService, AlertService, CommonService, TableHeader} from '../../../services/index'
import { Router } from '@angular/router';
import { Util } from '../../../utils'
declare var $:any;
import _ from 'lodash';



@Component({
  selector: 'fwdr-list',
  templateUrl: 'fwdr-list.html' 
})
export class FwdrMngListContainer {
  getCorpListSub:Subscription;
  updateCorpStatusSub:Subscription;

  phoneFormatter: Function = Util.phoneFormatter;
  createRange: Function = Util.createRange;
  corpRegFormatter: Function = Util.corpRegFormatter;
  fwdrList:Array<Corporation>;
  tempFwdrList:Array<Corporation>;
  pager: any = {};
  pagedItems:any[];
  searchOption:SearchOption = new SearchOption();
  headerList:Array<TableHeader> = null;
  clickedHader:TableHeader;

  @Output() headerSortedEmit: EventEmitter<any> = new EventEmitter();
  @Output() clearHeaderEmit: EventEmitter<any> = new EventEmitter();
  

  constructor(
    private fwdrMngService: ForwarderService, 
    private pagerService: PagerService, 
    private alertService:AlertService, 
    private router:Router, 
    private commonService:CommonService
  ) {

    commonService.headerSortedEmit.subscribe(sortedData =>{
      this.tempFwdrList = sortedData;
      this.setPage(1);
    });
    commonService.clearHeaderEmit.subscribe(headers =>{
      this.headerList = headers;
    });
  }
  
  ngOnInit() {

    if(this.fwdrMngService.fwdrListSearchOption != null){
      this.searchOption = this.fwdrMngService.fwdrListSearchOption;
    }

    if(this.fwdrMngService.fwdrListPager != null){
      this.pager = this.fwdrMngService.fwdrListPager;
      this.search(this.pager.currentPage);
    }else{
      this.search(1);
    }

    if(this.fwdrMngService.fwdrListHeader != null){
      this.headerList = this.fwdrMngService.fwdrListHeader;
    }else{
      this.makeHeader();
    }
  }

  makeHeader(){
    this.headerList = new Array<TableHeader>();
    this.headerList.push(new TableHeader(0, 'corpId', 'No.', true));
    this.headerList.push(new TableHeader(1, 'statusCd', '상태구분', true));
    this.headerList.push(new TableHeader(2, 'isReqModify', '수정 요청', true));
    this.headerList.push(new TableHeader(2, 'typeCd', '회사구분', true));
    this.headerList.push(new TableHeader(3, 'corpNm', '회사명', true));
    this.headerList.push(new TableHeader(4, 'lastNm', '요청자명', true));
    this.headerList.push(new TableHeader(5, 'email', '요청자 이메일', true));
    this.headerList.push(new TableHeader(6, 'tel', '요청자 연락처', false));
    this.headerList.push(new TableHeader(7, 'eco', '대표자명', false));
    this.headerList.push(new TableHeader(8, 'tel', '연락처', false));
    this.headerList.push(new TableHeader(9, 'corpRegNo', '사업자번호', false));
    this.headerList.push(new TableHeader(10, 'url', '홈페이지', false));
    this.headerList.push(new TableHeader(11, 'address', '본사주소', false));
    this.headerList.push(new TableHeader(12, 'isPartner', '파트너 여부', true));
    this.headerList.push(new TableHeader(13, 'isAuth', '인증 여부', true));
    
  }

  ngOnDestroy(){
    if(this.getCorpListSub) this.getCorpListSub.unsubscribe();
    if(this.updateCorpStatusSub) this.updateCorpStatusSub.unsubscribe();
  }

  search(page){
    this.getCorpListSub = this.fwdrMngService.getCorpList().subscribe((res:any)=>{
      this.fwdrList = res.data;
      this.tempFwdrList = this.fwdrList;

      if(this.fwdrMngService.fwdrClickedHeader != null){
        this.clickedHader = this.fwdrMngService.fwdrClickedHeader;
        
        if(this.clickedHader.orderBy.indexOf("ASC") > -1){
          this.clickedHader.orderBy = 'DESC';
        }else{
          this.clickedHader.orderBy = 'ASC';
        }

        this.commonService.headerClick(this.clickedHader, this.tempFwdrList);
      }

      this.conditionSearch(page);
      // this.setPage(page);
    });
  }
  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.tempFwdrList.length, page);
    // if (page < 1) {
    //   return;
    // } 
    
    this.pagedItems = this.tempFwdrList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    
  }

  updateStatus(statusCd, corpId, event){

    event.stopPropagation();
    
    let confirmMsg = "승인";
    if(statusCd == 2){
      confirmMsg = "취소";
    }
    
    let that = this;
    $.sweetModal.confirm(confirmMsg + " 상태로 변경하시겠습니까?", function() {
      let fwdr:Corporation = new Corporation();
      fwdr.statusCd = statusCd;
      fwdr.corpId = corpId;
      that.updateCorpStatusSub = that.fwdrMngService.updateFwdrCorpStatusCd(fwdr).subscribe(
        res=>{
          if(res.result){
            that.alertService.success('상태 변경이 완료되었습니다.');
            that.search(that.pager.currentPage);
          }
        }
      );
    });
  }

  conditionSearch(page?:number){
    if(_.isEmpty(this.fwdrList)) return;
    
    let keyword = _.upperCase(this.searchOption.conditionText).replace(/\s/gi, "");
    let statusCd = this.searchOption.conditionType;
    this.tempFwdrList = _.map(_.filter(this.fwdrList,
      (fwdr:Corporation) => {
        let lastName = '';
        let firstName = '';
        let tempEmail = '';
        if(fwdr.regUser){
          lastName = fwdr.regUser.lastNm ? fwdr.regUser.lastNm : '';
          firstName = fwdr.regUser.firstNm ? fwdr.regUser.firstNm : '';
          tempEmail = fwdr.regUser.email ? fwdr.regUser.email : '';
        }
        if(!keyword) return true;
        else if (_.upperCase(fwdr.tel ? fwdr.tel : '').replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(lastName + firstName).replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(fwdr.corpNm ? fwdr.corpNm : '').replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(fwdr.corpRegNo ? fwdr.corpRegNo : '').replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(tempEmail ? tempEmail : '').replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else return false;
      }));
    this.tempFwdrList = _.map(_.filter(this.tempFwdrList,
      (fwdr:Corporation) => {
        if(statusCd == 99) return true;
        else if(fwdr.statusCd == statusCd) return true;
        else return false;
      }));
    this.setPage(page == null || page == undefined ? 1 : page);
    this.commonService.clearOrderByHeader(this.headerList);
  }
  selectConditionType(event){
    this.searchOption.conditionType = event;
    this.conditionSearch();
  }

  handleKeyDown(event){
    if(event.keyCode == 13) this.conditionSearch();
  }

  moveFwdrDetail(corpId){
    this.fwdrMngService.fwdrListPager = this.pager;
    this.fwdrMngService.fwdrListSearchOption = this.searchOption;
    this.fwdrMngService.fwdrClickedHeader = this.clickedHader;
    this.fwdrMngService.fwdrListHeader = this.headerList;

    this.router.navigate(['/fwdr/setting', corpId]);
  }

  headerClick(header:TableHeader){
    this.clickedHader = header;
    this.fwdrMngService.fwdrClickedHeader = header;
    this.commonService.headerClick(header, this.tempFwdrList);
  }

}

class SearchOption {
  conditionText:string;
  conditionType:number = 99;
}



// WEBPACK FOOTER //
// ./src/app/containers/fwdr/mng/fwdr-list.ts